import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {SubnavSchema} from '../components/subnav'

export const TemplateFlexSuiteCategorySchema = buildEntrySchemaFor('templateFlexSuiteCategory', {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
      subNav: safeOptional(SubnavSchema),
    }),
  ),
})

export type TemplateFlexSuiteCategory = z.infer<typeof TemplateFlexSuiteCategorySchema>
